module.exports = __webpack_public_path__ + "media/images/icons/up-1772fc00b10ac2040108a4cc50837d82.png";